// extracted by mini-css-extract-plugin
export default {"button":"oryx-arrow-button_button__1SuuU"};